
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speak-law",
      function () {
        return require("private-next-pages/speak-law.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speak-law"])
      });
    }
  